import actionTypes from '../constants/action-types';

const setPageUsedBlock = (pageId, usedBlocks) => ({
  type: actionTypes.SET_PAGE_USED_BLOCKS,
  payload: {
    pageId,
    usedBlocks,
  },
});

export default setPageUsedBlock;
